import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';
import React from 'react';

const styles = require('./MissingDetail.module.scss');

export interface MissingDetailProps {
  className?: string;
  icon: string;
  label: string;
}

const MissingDetail: React.FC<MissingDetailProps> = ({ className, icon, label }) => {
  return (
    <div className={classNames(styles.container, className)}>
      <Icon name={icon} size="md" color="caption" aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default MissingDetail;
